<app-auth-layout>
  <app-sign-in-form *ngIf="!this.sso"></app-sign-in-form>
  <app-sign-in-flow *ngIf="this.sso"></app-sign-in-flow>
</app-auth-layout>
